<template>
  <div id="testBuilderDetailView">
    <b-col lg="8">
      <h1>
        {{$t('privatePage.testbuilder_testmethods_header')}}
      </h1>
        <test-builder-detail-editor
          :questionFormat="questionFormat"
          :availableScales="availableScales"
          :instructions="instructions"
          :currentCustomTestMethod="currentCustomTestMethod"
          @onSubmit="onSubmit"
          @showScaleCountError="showScaleCountError"
        />
    </b-col>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TestBuilderDetailEditor from '../../components/testmethods/testbuilder/testbuilderdetaileditor'

export default {
  components: {
    TestBuilderDetailEditor
  },
  data() {
    return {
      availableScales: []
    }
  },
  computed: {
    ...mapGetters(['defaultCulture', 'selectedCulture']),
    ...mapGetters('testMethodsModule', ['questionFormats']),
    ...mapGetters('userGroupsModule', ['currentCustomTestMethod']),
    ...mapGetters('instructionsModule', ['instructions']),
    submitMessage() {
      return this.$t('save_ok_feedback')
    },
    questionFormat: function() {
      return this.questionFormats.filter(
        questionFormat => questionFormat.id === 1
      )[0]
    }
  },
  methods: {
    ...mapActions('userGroupsModule', {
      selectCustomTestMethod: 'selectCustomTestMethod',
      getAvailableScales: 'getAvailableScales',
      getCustomTestMethod: 'getCustomTestMethod',
      addCustomTestMethod: 'addCustomTestMethod',
      updateCustomTestMethod: 'updateCustomTestMethod'
    }),
    ...mapActions('instructionsModule', {
      getAllInstructions: 'getAllInstructions'
    }),
    ...mapActions({
      showErrorMessage: 'showErrorMessage',
      showSuccessMessage: 'showSuccessMessage'
    }),
    onSubmit(data) {
      if (data.id) {
        this.updateCustomTestMethod({
          testMethod: data,
          languageId: this.selectedCulture.languageId
        })
          .then(() => {
            this.currentCustomTestMethod.scales = this.mapScales(
              this.currentCustomTestMethod.scales
            )
            this.showSuccessMessage(this.submitMessage)
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      } else {
        this.addCustomTestMethod({
          testMethod: data,
          languageId: this.selectedCulture.languageId
        })
          .then(() => {
            this.currentCustomTestMethod.scales = this.mapScales(
              this.currentCustomTestMethod.scales
            )
            this.showSuccessMessage(this.submitMessage)
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      }
    },
    showScaleCountError() {
      this.showErrorMessage(this.$t('privatePage.error_scales_count'))
    },
    mapScales(scales) {
      return scales.map(scale => {
        return {
          id: scale.id,
          name: scale.name,
          cc: scale.translations.map(translation => translation.countryCode)
        }
      })
    }
  },
  props: ['selectedTestMethod'],
  created() {
    this.getAvailableScales({
      questionFormat: this.questionFormat.id,
      languageId: this.selectedCulture.languageId,
      defaultLanguageId: this.defaultCulture.languageId
    }).then(response => {
      this.availableScales = this.mapScales(response)
    })

    this.getAllInstructions()

    if (this.selectedTestMethod !== undefined && this.selectedTestMethod.id) {
      this.availableScales = []

      this.getCustomTestMethod({
        testMethod: this.selectedTestMethod,
        languageId: this.selectedCulture.languageId
      }).then(testMethod => {
        testMethod.scales = this.mapScales(testMethod.scales)
        this.getAvailableScales({
          questionFormat: testMethod.questionFormatId,
          languageId: this.selectedCulture.languageId,
          defaultLanguageId: this.defaultCulture.languageId
        }).then(response => {
          let scales = []
          let availableScales = this.mapScales(response)
          availableScales.forEach(scale => {
            if (testMethod.scales.filter(s => s.id === scale.id).length === 0) {
              scales.push(scale)
            }
          })
          this.availableScales = scales
        })
      })
    } else {
      this.selectCustomTestMethod({ scales: [] })
    }
  }
}
</script>

<style>
.tabContent {
  margin-top: 30px;
}
</style>
